import { FormControlData, FormControlValue, CreateFormControlProps, ICollectionInput } from "../model";
import { createFormControl } from "solid-forms";
import { Label, Input, Error } from "../views";

export function createInput<V extends FormControlValue, D extends FormControlData = FormControlData>(
  ...args: CreateFormControlProps<V, D>
): ICollectionInput<V, D> {
  const control = createFormControl<V, D>(...args);
  const name = String(control.id);
  return {
    control,
    name,
    Label: (props) => <Label control={control} for={name} {...props} />,
    Error: (props) => <Error control={control} {...props} />,
    Input: (props) => <Input control={control} name={name} {...props} />,
  };
}
